import {
  ActionSheetButton,
  ActionSheetController,
  IonicPage,
  NavParams,
  ViewController,
} from 'ionic-angular';
import { Component } from '@angular/core';

import {
  CreateAndCompleteOrderParams,
  OpsOrderModel,
  OrderCompleteParams,
} from '../../models/order.ops';
import { LoadingAlertProvider } from '../../providers/loading-alert/loading-alert';
import { OpsProvider } from '../../providers/ops/ops';
import { ServiceModel } from '../../models/service';
import { TruckModel } from '../../models/truck';
import { UserModel } from '../../models/user';

export interface OrderCompletePageProps {
  order?: OpsOrderModel;
  params?: CreateAndCompleteOrderParams;
  truck: TruckModel;
  isFleet: boolean;
  isClockedIn: boolean;
  service: ServiceModel;
  user?: UserModel;
}

interface OrderCompletePageForm {
  truck?: TruckModel;
  note?: string;
}

@IonicPage()
@Component({
  selector: 'page-order-complete',
  templateUrl: 'order-complete.html',
})
export class OrderCompletePage {
  props: OrderCompletePageProps;
  form: OrderCompletePageForm;

  didCompleteOrder: (order: OpsOrderModel) => void;

  constructor(
    navParams: NavParams,
    private opsService: OpsProvider,
    private viewCtlr: ViewController,
    private actionSheetCtrl: ActionSheetController,
    private loadingAlert: LoadingAlertProvider
  ) {
    this.props = navParams.get('props');
    this.didCompleteOrder = navParams.get('didCompleteOrder');
    this.form = {
      truck: this.props.truck,
    };
  }

  // Actions

  didTapCompleteOrder() {
    this.saveOrder();
  }

  showWarningActionSheet(title: string, buttons: ActionSheetButton[]) {
    this.actionSheetCtrl
      .create({
        title,
        buttons,
      })
      .present();
  }

  // Data

  saveOrder() {
    if (this.props.order) {
      this.completeOrder(this.props.order);
    } else if (this.props.params) {
      this.createAndCompleteOrder(this.props.params);
    }
  }

  createAndCompleteOrder(params: CreateAndCompleteOrderParams) {
    if (this.form.note) {
      params.note = this.form.note;
    }
    this.loadingAlert.showLoader();
    this.opsService.createAndCompleteOrder(params).subscribe(
      order => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastConfirmation('Order completed');
        if (this.didCompleteOrder) {
          this.didCompleteOrder(order);
        }
        this.viewCtlr.dismiss({
          order: order,
        });
      },
      () => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastAlert('Error completing order');
      }
    );
  }

  completeOrder(order: OpsOrderModel) {
    const params: OrderCompleteParams = {};
    if (this.form.note) {
      params.note = this.form.note;
    }
    this.loadingAlert.showLoader();
    this.opsService.completeOrder(order, params).subscribe(
      order => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastConfirmation('Order completed');
        if (this.didCompleteOrder) {
          this.didCompleteOrder(order);
        }
        this.viewCtlr.dismiss({
          order: order,
        });
      },
      () => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastAlert('Error completing order');
      }
    );
  }

  didTapDismiss() {
    this.viewCtlr.dismiss();
  }

  // Helpers

  get validates(): boolean {
    if (!this.props.isClockedIn && !this.props.isFleet) {
      return false;
    }
    return true;
  }
}



// WEBPACK FOOTER //
// ./src/pages/order-complete/order-complete.ts